import i18n from '@/utils/i18n';
import React from 'react';
import { Button, Props as ButtonProps } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { EmptyStateMinimal } from '@/components/empty-state-minimal';
import { StyleProp, ViewStyle } from 'react-native';

interface Props {
  buttonProps?: ButtonProps;
  containerStyle?: StyleProp<ViewStyle>;
  searchText: string;
}

export const SearchEmptyState: React.FC<Props> = ({
  buttonProps,
  containerStyle,
  searchText,
}) => {
  const [styles] = useStyles();
  return (
    <EmptyStateMinimal
      containerStyle={[styles.base, containerStyle]}
      text={i18n.t('order_guide_search.empty_state', {
        searchTerm: searchText,
      })}
    >
      {buttonProps ? (
        <Button
          {...buttonProps}
          containerStyle={[styles.buttonContainer, buttonProps.containerStyle]}
        />
      ) : null}
    </EmptyStateMinimal>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    backgroundColor: theme.colors.white,
  },
  buttonContainer: {
    marginTop: 16,
  },
}));
